module.exports = __webpack_public_path__ + "static/media/astro-logo-white.6f66f3d2.svg";